import React, { Component } from 'react';
import ReactPaginate from 'react-paginate';
import { translate } from 'react-i18next';
import Navigation from '../components/Navigation';
import FactTypeTable from '../components/FactTypeTable';
import PaginationPanel from '../components/PaginationPanel';
import config from '../config';
import { Link } from 'react-router-dom';

import axios from 'axios';
import {
    Panel,
    Col,
    Row,
    Button,
    FormControl,
    InputGroup,
    FormGroup
} from 'react-bootstrap';

import './FactTypes.css';

class FactTypes extends Component {
    constructor(props) {
        super(props);

        this.state = {
            facttypes: [],
            page: props.page,
            limit: 40,
            search: props.search,
            pageCount: 0,
            selected: props.selected - 1
        };
    }

    componentDidMount() {
        this.loadFactTypesFromServer();
    }

    deleteFactType(facttype) {
        var self = this;
        axios
            .delete(`${config.baseURL}/facttypes/${facttype.id}`)
            .then(function(response) {
                self.loadFactTypesFromServer()();
            })
            .catch(function(error) {
                console.log(error);
            });
    }

    loadFactTypesFromServer() {
        var self = this;
        axios
            .get(`${config.baseURL}/facttypes`, {
                params: {
                    page: self.state.page,
                    limit: self.state.limit,
                    search: self.state.search
                }
            })
            .then(function(response) {
                self.setState({
                    facttypes: response.data.factTypes,
                    pageCount: response.data.pageCount
                });
            })
            .catch(function(error) {
                console.log(error);
            });
    }

    handlePageClick = data => {
        let selected = data.selected + 1;

        const url = new URL(window.location.href);
        url.searchParams.set('page', selected);
        window.history.pushState(null, null, url);

        this.setState({ page: selected, selected: data.selected }, () => {
            this.loadFactTypesFromServer();
        });
    };

    handleChange = event => {
        this.setState({
            [event.target.id]: event.target.value
        });
    };

    handleSubmit = event => {
        const { t } = this.props;

        const url = new URL(window.location.href);

        if(this.state.search) {
            url.searchParams.set('search', this.state.search);
        } else {
            url.searchParams.delete('search');

        }
        window.history.pushState(null, null, url);

        event.preventDefault();
        this.loadFactTypesFromServer();
    };

    render() {
        const { t } = this.props;
        document.title = `MySign Digital Screen Solutions | ${t(
            'FactTypes.title'
        )}`;

        return (
            <div className="FactTypes">
                <div id="wrapper">
                    <Navigation props={this.props} />
                    <div id="content-wrapper">
                        <Row>
                            <Col lg={12}>
                                <h1 className="page-header">
                                    {t('FactTypes.title')}

                                    <Link
                                        type="submit"
                                        className="btn btn-primary"
                                        to="/facts/facttypes/create"
                                    >
                                        <em className="fa fa-plus fa-fw" />{' '}
                                        {t('FactTypes.add_facttype')}
                                    </Link>
                                </h1>

                                <ol className="breadcrumb">
                                    <li>
                                        <i className="fa fa-info" />{' '}
                                        <Link to={`/facts`}>
                                            {t('Facts.title')}
                                        </Link>
                                    </li>
                                    <li className="active">
                                        <i className="fa fa-list" />{' '}
                                        {t('FactTypes.title')}
                                    </li>
                                </ol>

                                <PaginationPanel
                                    heading={
                                        <Row>
                                            <Col xs={12} className="text-right">
                                                <form
                                                    role="search"
                                                    onSubmit={this.handleSubmit}
                                                >
                                                    <FormGroup controlId="search">
                                                        <InputGroup>
                                                            <FormControl
                                                                type="text"
                                                                value={
                                                                    this.state
                                                                        .search
                                                                }
                                                                onChange={
                                                                    this
                                                                        .handleChange
                                                                }
                                                                placeholder={t(
                                                                    'Search'
                                                                )}
                                                            />
                                                            <InputGroup.Button>
                                                                <Button
                                                                    onClick={
                                                                        this
                                                                            .handleSubmit
                                                                    }
                                                                >
                                                                    <i className="glyphicon glyphicon-search" />
                                                                </Button>
                                                            </InputGroup.Button>
                                                        </InputGroup>
                                                    </FormGroup>
                                                </form>
                                            </Col>
                                        </Row>
                                    }
                                    pagination={
                                        <ReactPaginate
                                            previousLabel={t(
                                                'Pagination.previous'
                                            )}
                                            nextLabel={t('Pagination.next')}
                                            breakLabel={<Link to="#">...</Link>}
                                            breakClassName={'break-me'}
                                            pageCount={this.state.pageCount}
                                            marginPagesDisplayed={3}
                                            pageRangeDisplayed={5}
                                            onPageChange={this.handlePageClick}
                                            containerClassName={'pagination'}
                                            subContainerClassName={
                                                'pages pagination'
                                            }
                                            activeClassName={'active'}
                                            forcePage={this.state.selected}
                                        />
                                    }
                                >
                                    <FactTypeTable
                                        facttypes={this.state.facttypes}
                                        onDelete={this.deleteFactType.bind(
                                            this
                                        )}
                                    />
                                </PaginationPanel>
                            </Col>
                        </Row>
                    </div>
                </div>
            </div>
        );
    }
}
export default translate('translations')(FactTypes);
